import React from 'react';
import Header from '../HeaderAndFooter/Header';
import Footer from '../HeaderAndFooter/Footer';

export default function PageLayout({ children, fullBleed = false }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#F9FAFB] font-['Inter'] text-gray-900">
      <Header />
      <main
        className={
          fullBleed
            ? "flex-grow px-0 mt-0 mb-0"
            : "flex-grow px-0 mt-4 md:mt-12 mb-4 md:mb-12"
        }
      >
        {children}
      </main>
      <Footer />
    </div>
  );
}
